import { Resource, ResourceLanguage } from 'i18next';

import es from './es.json';
import en from './en.json';
import pt from './pt.json';
import fr from './fr.json';
import helpEs from './help/es.json';
import helpEn from './help/en.json';
import helpPt from './help/pt.json';
import helpFr from './help/fr.json';

export type SupportedLanguages = 'es' | 'en' | 'pt' | 'fr';

type TranslationDictionary = Record<string, unknown>;

const mergeHelpGuide = (
  baseTranslations: ResourceLanguage,
  helpTranslations: ResourceLanguage
): ResourceLanguage => {
  const baseDictionary = baseTranslations as TranslationDictionary;
  const helpDictionary = helpTranslations as TranslationDictionary;
  const baseHelp = (baseDictionary.help as TranslationDictionary | undefined) || {};
  const incomingHelp = (helpDictionary.help as TranslationDictionary | undefined) || {};

  return {
    ...baseDictionary,
    help: {
      ...baseHelp,
      ...incomingHelp,
      guide: incomingHelp.guide,
    },
  } as ResourceLanguage;
};

const translations: Record<SupportedLanguages, Resource> = {
  es: { translation: mergeHelpGuide(es as ResourceLanguage, helpEs as ResourceLanguage) },
  en: { translation: mergeHelpGuide(en as ResourceLanguage, helpEn as ResourceLanguage) },
  pt: { translation: mergeHelpGuide(pt as ResourceLanguage, helpPt as ResourceLanguage) },
  fr: { translation: mergeHelpGuide(fr as ResourceLanguage, helpFr as ResourceLanguage) },
};

export default translations;
